export const ALLOWED_PORTAL_ACCESS = ['G_UPP_Partner_Admin_User', 'G_UPP_Partner_User']
